<template>
  <form
    method="POST"
    action="https://nederlandsmijnmuseum.activehosted.com/proc.php"
    id="_form_2_"
    class="_form _form_2 _inline-form _dark"
    novalidate
    @submit="submitForm"
  >
    <input type="hidden" name="u" value="2" />
    <input type="hidden" name="f" value="2" />
    <input type="hidden" name="s" />
    <input type="hidden" name="c" value="0" />
    <input type="hidden" name="m" value="0" />
    <input type="hidden" name="act" value="sub" />
    <input type="hidden" name="v" value="2" />
    <div class="_form-content">
      <input
        type="text"
        name="fullname"
        placeholder="Naam"
        autocomplete="off"
      />
      <input
        type="text"
        name="email"
        placeholder="E-mail adres"
        required
        autocomplete="off"
      />
      <div class="_button-wrapper _full_width">
        <button id="_form_2_submit" class="_submit" type="submit">
          Inschrijven <Icon type="arrow-right" />
        </button>
      </div>
    </div>
    <div class="_form-thank-you" style="display: none"></div>
  </form>
</template>

<script src="./NewsletterForm.js" lang="js" />
<style src="./NewsletterForm.scss" lang="scss" scoped />
